import { AnnotationType } from 'types/building'
import { getRNAnnotationCategory } from 'utils/annotationRN'

import useDirectory from './useDirectory'

const DEFAULT_ANNOTATION_BG_COLORS: Record<number, string> = {
  [AnnotationType.ARCHITECTURE]: 'bg-[#454DFF]',
  [AnnotationType.ELECTRICITY]: 'bg-[#F1AE00]',
  [AnnotationType.AIR_CONDITION]: 'bg-[#02EADC]',
  [AnnotationType.EQUIPMENT]: 'bg-[#A074F8]',
  [AnnotationType.FIRE]: 'bg-[#FF4242]',
  [AnnotationType.FLOOD]: 'bg-[#015CB9]',
  [AnnotationType.EARTHQUAKE]: 'bg-[#EDE054]',
  [AnnotationType.VOLCANO]: 'bg-[#64A45F]',
  [AnnotationType.LIFE_LINE]: 'bg-[#FE7F00]',
  [AnnotationType.IMAGE]: 'bg-[#454DFF]',
  [AnnotationType.MOVIE]: 'bg-[#FF4242]',
  [AnnotationType.INFO]: 'bg-[#02EADC]'
}

export default function useGetAnnotationColor() {
  const { isRN } = useDirectory()

  const getAnnotationBgColor = (annotationType: number) => {
    if (isRN) {
      return getRNAnnotationCategory(annotationType).bgClass
    }

    return DEFAULT_ANNOTATION_BG_COLORS[annotationType] || 'bg-[#4B4B4B]'
  }

  return { getAnnotationBgColor }
}
